/**
 * A user without any project gets this catalog placeholder so the shell can render its empty state.
 * It is never a stored project: nothing may read from or write to the API under this ID.
 */
export const SYNTHETIC_DEFAULT_PROJECT_ID = 'default';

export const isPersistedProjectId = (projectId: string | null | undefined): projectId is string =>
  typeof projectId === 'string' && projectId.length > 0 && projectId !== SYNTHETIC_DEFAULT_PROJECT_ID;
